// touch i18n.ts
import i18n from 'i18next';
import detector from 'i18next-browser-languagedetector';
// import httpBackend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

import en_US from './locales/en-US';
import zh_CN from './locales/zh-CN';
import zh_TW from './locales/zh-HK';

i18n
  .use(initReactI18next) // 将 i18n 向下传给 react-i18next
  .use(detector) // 默认语言自动检测
  .init({
    detection: {
      caches: []
    },
    resources: {
      en_US: {
        translation: en_US
      },
      zh_CN: {
        translation: zh_CN
      },
      zh_TW: {
        translation: zh_TW
      },
      en: {
        translation: en_US
      },
      zh: {
        translation: zh_CN
      }
    },
    fallbackLng: 'zh_CN' // 回滚语言
  });

export default i18n;
